import { Translation } from '../types';

export default {
  // 应用程序
  appTitle: "OK Money - 人生规划模拟器",
  
  // 导航
  navigation: {
    home: "首页",
    lifePlan: "人生规划",
    riskSimulation: "风险模拟",
    contact: "联系我们",
    openMenu: "打开菜单",
    lifePlanDescription: "创建人生规划，设计您的未来生活",
    riskSimulationDescription: "运行风险模拟，评估投资风险",
  },

  // Home
  home: {
    hero: {
      title: "通过模拟实现真实生活规划",
      subtitle: "通过考虑不确定性的模拟来优化您的人生规划",
      download: "下载",
      docs: "文档"
    },
    features: {
      codeCompletion: {
        title: "实时模拟",
        description: "实时模拟市场波动，提供最优资金计划"
      },
      codebase: {
        title: "AI分析",
        description: "使用历史数据和AI分析您的投资组合，并提出改进建议"
      },
      naturalLanguage: {
        title: "丰富生活的投资",
        description: "通过投资增加资产，同时确保日常生活所需资金的安全"
      }
    },
  },

  // 公司信息和条款
  company: {
    title: "公司信息",
    basicInfo: "基本信息",
    operatorName: "运营公司名称",
    startDate: "成立日期",
    startDateValue: "2025年4月28日",
    location: "所在地",
    locationValue: "神奈川县横滨市",
    contact: "联系我们",
    contactForm: "联系表单",
    businessDescription: "业务内容",
    businessDescriptionContent: "提供人生规划模拟服务",
    developerProfile: "开发者简介",
    developerProfileContent: "由SIer工程师个人开发。随着孩子的出生，我们致力于开发一个能够帮助人们规划未来、充分享受现在生活的服务。",
    privacyPolicy: "隐私政策",
    privacyPolicyLink: "查看完整隐私政策",
    termsOfService: "服务条款",
    termsOfServiceContent: "我们非常重视保护客户的个人信息。",
    contentEnd: "如有任何疑问，请联系我们。"
  },
  terms: {
    title: "服务条款",
    termsOfService: "服务条款",
    privacyPolicy: "隐私政策",
    article1: {
      title: "第1条（适用范围）",
      content: "本条款规定了OKMoney（以下简称\"本公司\"）提供的服务（以下简称\"本服务\"）的使用条件。"
    },
    article2: {
      title: "第2条（用户注册）",
      content1: "1. 使用本服务需要同意本条款，并按照本公司规定的方式进行注册。",
      content2: "2. 本公司认为注册申请者存在以下情况时，可以拒绝注册：",
      listItem1: "曾违反本条款的申请者",
      listItem2: "其他本公司认为不适合注册的情况"
    },
    article3: {
      title: "第3条（禁止事项）",
      content: "用户不得进行以下行为：",
      listItem1: "违反法律法规或公序良俗的行为",
      listItem2: "与犯罪行为相关的行为",
      listItem3: "可能妨碍本公司服务运营的行为",
      listItem4: "对其他用户造成困扰的行为",
      listItem5: "其他本公司认为不适当的行为"
    },
    article4: {
      title: "第4条（服务停止等）",
      content: "本公司认为存在以下情况时，可以不经事先通知用户而停止或中断本服务的全部或部分：",
      listItem1: "对本服务相关的计算机系统进行维护检查或更新时",
      listItem2: "因地震、雷击、火灾、停电或天灾等不可抗力导致本服务提供困难时",
      listItem3: "其他本公司认为本服务提供困难的情况"
    },
    article5: {
      title: "第5条（免责事项）",
      content: "本公司对用户与其他用户或第三方之间因本服务产生的交易、联系或纠纷等不承担任何责任。"
    },
    article6: {
      title: "第6条（服务内容变更等）",
      content: "本公司可以不经通知用户而变更本服务内容或中止本服务，对此给用户造成的损害不承担任何责任。"
    },
    article7: {
      title: "第7条（条款变更）",
      content: "本公司认为必要时，可以不经通知用户而随时变更本条款。"
    },
    article8: {
      title: "第8条（通知或联系）",
      content: "用户与本公司之间的通知或联系应按照本公司规定的方式进行。"
    },
    article9: {
      title: "第9条（禁止转让权利义务）",
      content: "未经本公司书面事先同意，用户不得将使用合同上的地位或基于本条款的权利义务转让给第三方或作为担保。"
    },
    article10: {
      title: "第10条（准据法・管辖法院）",
      content1: "1. 本条款的解释适用日本法律。",
      content2: "2. 因本服务发生纠纷时，以本公司总部所在地的法院为专属管辖法院。"
    },
    privacy: {
      article1: {
        title: "1. 关于个人信息的收集",
        content: "本网站提供服务时，可能会收集以下个人信息：",
        listItem1: "姓名",
        listItem2: "电子邮件地址",
        listItem3: "地址",
        listItem4: "电话号码",
        listItem5: "其他提供服务所需的信息"
      },
      article2: {
        title: "2. 个人信息的使用目的",
        content: "收集的个人信息将用于以下目的：",
        listItem1: "提供和运营服务",
        listItem2: "处理咨询",
        listItem3: "改进和开发服务",
        listItem4: "发送重要通知"
      },
      article3: {
        title: "3. 个人信息的管理",
        content: "本网站为防止个人信息泄露、丢失或损坏，实施了适当的安全措施。"
      },
      article4: {
        title: "4. 向第三方提供个人信息",
        content: "除以下情况外，本网站不会向第三方提供个人信息：",
        listItem1: "获得本人同意时",
        listItem2: "基于法律法规时",
        listItem3: "为保护人的生命、身体或财产必要时"
      },
      article5: {
        title: "5. 咨询",
        content: "关于隐私政策的咨询，请通过联系表单联系我们。"
      },
      article6: {
        title: "6. 隐私政策的变更",
        content: "本网站可能会根据需要变更本隐私政策。变更时将在本网站公布。"
      }
    }
  },

  // 通用
  common: {
    years: "年",
    perYear: "/年",
    perMonth: "/月",
    age: "年龄",
    yes: "是",
    no: "否",
    none: "无",
    notEntered: "未输入",
    add: "添加",
    delete: "删除",
    save: "保存",
    cancel: "取消",
    reset: "重置",
    month: "月",
    select: "选择",
    clearSelection: "清除选择",
    dateTime: "日期和时间",
    actions: "操作",
    currencies: {
      jpy: "日元",
      usd: "美元",
      eur: "欧元",
      gbp: "英镑",
      aud: "澳元",
      cad: "加元",
      chf: "瑞士法郎",
      cny: "人民币",
      hkd: "港币",
      sgd: "新加坡元"
    },
    currency: "货币",
    currencyHelp: "请选择货币。模拟将以所选货币进行。",
    statistics: {
      title: "统计",
      mean: "平均值",
      median: "中位数",
      min: "最小值",
      max: "最大值",
      mode: "众数",
      totalInvestment: "总投资额",
      assetDistribution: "资产分配",
      targetAchieveRate: "目标达成率",
      probability: "概率",
      medianFinalAsset: "中位数最终资产",
      finalAsset: "最终资产",
    }
  },

  // 风险模拟
  riskSimulation: {
    title: "风险模拟",
    simulationSettings: "模拟设置",
    initialInvestment: "初始投资额",
    investmentAmount: "投资额",
    investmentPeriod: "投资期限",
    annualReturnRate: "年回报率",
    monthlyInvestment: "月投资额",
    volatility: "波动率",
    targetAmount: "目标金额",
    runSimulation: "运行模拟",
    running: "运行中",
    simulationInstruction: "请先运行模拟。",
    noSimulationRun: "未运行模拟",
    simulationResults: "模拟结果",
    currentResults: "当前结果",
    savedResults: "已保存结果",
    compare: "比较",
    resultTitle: "风险模拟结果",
    simulationConditions: "模拟条件",
    saveSimulationResult: "保存模拟结果",
    saveSimulationDescription: "请输入模拟结果的名称。",
    simulationName: "模拟名称",
    simulationNamePlaceholder: "输入模拟结果名称",
    saveSimulation: "保存模拟",
    noSavedSimulations: "无保存的模拟",
    noSavedSimulationsDescription: "未找到保存的模拟。请先运行模拟。",
    createNewSimulation: "创建新模拟",
    selectSimulationsToCompare: "选择要比较的模拟",
    noSelectedSimulations: "未选择模拟",
    selectTwoOrMoreSimulations: "请选择两个或更多模拟。",
    comparisonResults: "比较结果",
    finalAssetComparison: "最终资产比较",
    finalAssetComparisonDescription: "模拟最终资产的比较",
    successRateComparison: "成功率比较",
    successRateComparisonDescription: "模拟成功率的比较",
    simulationParameters: "模拟参数",
    simulationParametersDescription: "模拟参数比较",
    period: "期间",
    successRate: "成功率",
    backToSimulation: "返回模拟",
  },

  // 人生规划
  lifePlan: {
    title: "创建人生规划",
    resultTitle: "人生规划模拟结果",
    steps: {
      basicInfo: "基本信息",
      incomeExpense: "收支",
      assetsLiabilities: "资产负债",
      lifeGoals: "人生事件",
      simulationSettings: "模拟设置",
      confirmation: "确认",
    },
    navigation: {
      prev: "上一步",
      next: "下一步",
      startSimulation: "开始模拟",
      confirmStart: "是否开始模拟？",
      confirmStartTitle: "确认开始模拟",
      cancel: "取消",
    },
    basicInfo: {
      title: "基本信息",
      name: "姓名",
      namePlaceholder: "输入姓名",
      age: "年龄",
      gender: {
        title: "性别",
        male: "男",
        female: "女",
        other: "其他",
      },
      familyStructure: {
        title: "家庭结构",
        hasSpouse: "有配偶",
        spouseAge: "配偶年龄",
        children: "子女",
        help: "输入家庭结构",
        childrenHelp: "输入子女年龄",
        addChild: "添加子女",
        removeChild: "删除子女",
        noChildren: "无子女",
      },
      spouse: "配偶",
      children: "子女"
    },
    incomeExpense: {
      title: "收支",
      income: {
        title: "收入",
        annualIncome: "年收入（万元）",
        salaryIncreaseRate: "加薪率（%）",
        annualBonus: "年终奖（万元）",
      },
      expense: {
        title: "支出",
        help: "请输入月支出",
        housingCost: "住房费用（万元/月）",
        housingCostHelp: "请输入月租金或贷款还款额",
        utilities: "水电费（万元/月）",
        food: "食品费（万元/月）",
        communication: "通信费（万元/月）",
        transportation: "交通费（万元/月）",
        entertainment: "娱乐费（万元/月）",
        investment: "投资（万元/月）",
        stocks: "股票投资（万元/月）",
        bonds: "债券投资（万元/月）",
        mutualFunds: "基金投资（万元/月）",
        insurance: "保险费（万元/月）",
        other: "其他（万元/月）"
      },
      annualIncome: "年收入",
      salaryIncreaseRate: "加薪率",
      annualBonus: "年终奖",
      housingCost: "住房费用",
      utilities: "水电费",
      food: "食品费",
      communication: "通信费",
      transportation: "交通费",
      entertainment: "娱乐费",
      other: "其他"
    },
    assetsLiabilities: {
      title: "资产负债",
      assets: {
        title: "资产",
        savings: "储蓄",
        stocks: "股票",
        bonds: "债券",
        mutualFunds: "基金",
        insurance: "保险",
        other: "其他",
        amount: "金额（万元）",
        return: "预期回报（%）",
        volatility: "波动率（%）",
        investmentAssets: "投资资产",
      },
      liabilities: {
        title: "负债",
        housingLoan: "住房贷款",
        carLoan: "汽车贷款",
        otherLoans: "其他贷款",
        addLoan: "添加贷款",
        removeLoan: "删除贷款",
        name: "贷款名称",
        amount: "贷款金额（万元）",
        period: "还款期限（年）",
        interestRate: "利率（%）",
        noLoans: "无贷款",
      },
      savings: "储蓄",
      stocks: "股票",
      bonds: "债券",
      mutualFunds: "基金",
      insurance: "保险",
      otherInvestments: "其他投资",
      housingLoanBalance: "住房贷款余额",
      housingLoanPeriod: "贷款期限",
      housingLoanInterest: "利率",
      noLoans: "无贷款",
      otherLoans: "其他贷款"
    },
    lifeGoals: {
      title: "人生事件",
      housingPurchase: "购房",
      educationFunds: "教育资金",
      child: "子女",
      otherGoals: "其他目标",
      retirementAge: "退休年龄",
      retirementMonthlyExpense: "退休后月支出",
      notPlanned: "未计划",
      housing: {
        title: "购房",
        planned: "计划购房",
        year: "计划购买年份",
        amount: "计划购买金额（万元）",
        purchaseAmount: "购买金额（万元）",
        purchaseYear: "购买年份",
      },
      education: {
        title: "教育资金计划",
        subtitle: "教育资金规划",
        add: "添加教育资金",
        remove: "删除教育资金",
        name: "教育资金名称",
        namePlaceholder: "输入教育资金名称",
        childAge: "子女年龄",
        age: "所需年龄",
        amount: "所需金额",
        requiredAmount: "所需金额",
        noData: "未添加教育资金",
      },
      other: {
        title: "其他目标",
        subtitle: "其他人生事件",
        add: "添加目标",
        remove: "删除目标",
        name: "目标名称",
        year: "目标年份",
        amount: "所需金额（百万日元）",
        noData: "暂无目标",
        namePlaceholder: "请输入其他目标名称",
        plannedAge: "计划年龄",
        requiredAmount: "所需金额"
      },
      retirement: {
        title: "退休计划",
        age: "计划退休年龄",
        monthlyExpense: "退休后月支出（万元）",
      },
    },
    simulationSettings: {
      title: "模拟设置",
      inflationRate: "通货膨胀率",
      investmentReturn: "投资回报率",
      simulationPeriod: "模拟期间",
      currency: "货币",
      currencyHelp: "选择货币。模拟将以所选货币进行。",
      inflationRateHelp: "考虑未来通货膨胀率的模拟。"
    },
    runningSimulation: "模拟运行中",
    result: {
      title: "人生规划模拟结果",
      settings: "人生规划设置",
      planSettings: "计划设置",
      actions: {
        print: "打印",
        downloadCSV: "下载CSV",
        modifyConditions: "修改条件",
        backToInput: "返回输入界面",
      },
      tabs: {
        charts: "图表",
        details: "详情",
        analysis: "分析・建议",
      },
      charts: {
        assetIncomeExpense: "资产・收支趋势",
        agePoint: "{age}岁时",
        spouse: "配偶：{age}岁",
        children: "子女",
        age: "{age}岁",
        assets: "资产",
        liabilities: "负债",
        netWorth: "净资产",
        amount: "金额（万元）",
        noData: "无数据",
        assetTrend: "资产趋势",
        incomeExpenseTrend: "收支趋势",
        income: "收入",
        expense: "支出",
        savings: "储蓄",
      },
      details: {
        yearlyData: "年度数据详情",
      },
      analysis: {
        risk: "风险分析",
        recommendations: "改进建议",
      },
      table: {
        search: "搜索...",
        age: "年龄",
        familyAge: "家庭年龄",
        income: "收入",
        expense: "支出",
        savings: "储蓄",
        assets: "资产余额",
        lifeEvents: "人生事件",
        ageValue: "{age}岁",
        spouse: "配偶：{age}岁",
        children: "子女",
        amount: "万元",
        noData: "无数据",
      },
      timeline: {
        age: "年龄",
        event: "事件",
        retirement: "退休",
        ageValue: "{age}岁",
        agePoint: "{age}岁时",
        spouse: "配偶：{age}岁",
        children: "子女",
        neededAmount: "需要金额：{amount}",
        assets: "资产：{amount}",
        education: "{childName}的{fundName}",
        child: "子女",
        educationFund: "教育资金"
      },
      summary: {
        title: "摘要",
        monthlyIncome: "月收入",
        monthlyExpense: "月支出",
        monthlyInvestment: "月投资额",
        monthlySavings: "月储蓄额",
        totalAssets: "总资产",
        totalLiabilities: "总负债",
        netWorth: "净资产",
        finalAssets: "最终资产",
        peakAssets: "峰值资产",
        retirementAssets: "退休时资产",
        savingsRate: "储蓄率",
        savingsRateDesc: "收入中储蓄的比例",
        retirementBalance: "退休后收支",
        balance: "收支",
        riskAssessment: "风险评估",
        riskLow: "低风险",
        riskMedium: "中等风险",
        riskHigh: "高风险",
        negativeAssets: "未来将出现资产为负的时期。",
        positiveAssets: "预计资产将始终保持正值。",
        needImprovement: "需要改善收支状况。",
        unit: "万元",
        atAge: "{age}岁时",
      },
      chart: {
        title: "资产趋势预览",
        noData: "请输入数据",
        assets: "资产",
        income: "收入",
        expense: "支出",
      },
    },
    confirmation: {
      title: "确认"
    },
    validation: {
      error: "输入内容有误。"
    },
  },
  login: "登录",
  register: "注册",
  loginDescription: "还没有账号？请注册。",
  registerDescription: "创建账号开始您的人生规划模拟。",
  email: "电子邮箱",
  password: "密码",
  passwordRequirements: "密码必须至少8个字符，并包含字母和数字。",
  loggingIn: "登录中...",
  registering: "注册中...",
  loginFailed: "登录失败。",
  registrationSuccess: "注册成功。",
  registrationFailed: "注册失败。",
  myPage: "我的账户",
  logout: "退出登录",
  userProfile: "用户资料",
  userProfileDescription: "管理您的个人资料信息",
  savedSimulations: "已保存的模拟",
  savedSimulationsDescription: "您保存的模拟结果列表",
  settings: "设置",
  accountSettings: "账户设置",
  accountSettingsDescription: "管理您的账户设置",
  changePassword: "修改密码",
  changePasswordDescription: "更改您的密码",
} as Translation; 